import { Box, Chip, Stack, Typography } from "@mui/material";
import { GatewayNumberDto, GatewayNumberStatus } from "../../../api/psc";
import { GetLabelForGatewayNumber } from "../constants/SmsCampaignContants";

export default function SmsGatewayNumberItem(props: {
    gatewayNumber: GatewayNumberDto;
}) {
    const gatewayNumberTitleAndColor = GetLabelForGatewayNumber(
        props.gatewayNumber
    );
    return (
        <Stack sx={{ width: "100%" }} direction="row" spacing={1}>
            <Typography>{props.gatewayNumber.displayName}</Typography>
            {props.gatewayNumber.status === GatewayNumberStatus.PRIVATE && (
                <Chip
                    variant="outlined"
                    size="small"
                    color="warning"
                    label="اختصاصی"
                />
            )}
            <Box sx={{ flexGrow: 1 }} />
            <Chip
                size="small"
                label={gatewayNumberTitleAndColor.title}
                sx={{
                    bgcolor: gatewayNumberTitleAndColor.color,
                    color: "white",
                }}
            />
        </Stack>
    );
}
